import { z } from 'zod';

/**
 * A single-use QR link request for the "reverse linking" flow: an unlinked iPad shows its
 * `sessionCode` as a QR, the owner scans it in the backoffice app and approves it for one of their
 * restaurants. Approval links the iPad in `iPads` and deletes this row — the iPad learns it linked
 * by watching its own `iPads` link status, not this row. Unlike a typed `iPadDeviceCode`, the
 * request is iPad-initiated (carries the iPad's `tokenHash`).
 */
export const iPadQrLinkRequestSchema = z.object({
  /** High-entropy nonce shown as the QR (scanned, not typed). Globally unique while active. */
  sessionCode: z.string(),
  /** sha256 (hex) of the iPad's Keychain iPad token — used to link the iPad row on approval; never exposed to clients. */
  tokenHash: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type IPadQrLinkRequest = z.output<typeof iPadQrLinkRequestSchema>;

export const iPadQrLinkRequestStrictSchema = iPadQrLinkRequestSchema.safeExtend({
  tokenHash: z.hash('sha256'),
});

export const iPadQrLinkRequestCvxSchema = iPadQrLinkRequestSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type IPadQrLinkRequestCvx = z.output<typeof iPadQrLinkRequestCvxSchema>;
